import React from 'react'
import { useTranslation } from 'react-i18next'
import { SearchSvg } from '../other/svg/Index'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
}

const SearchInput = ({ value, onChange }: SearchInputProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div
      className="w-64 h-10 px-3 py-2 bg-backgrounds-bg-field-component rounded-md flex justify-start items-center gap-2 overflow-hidden"
      style={{
        boxShadow: '0px 0px 0px 1px rgba(0,0,0,0.08), 0px 1px 2px 0px rgba(0,0,0,0.12)'
      }}>
      <div className="w-6 h-6 relative overflow-hidden text-icon-secondary">
        <SearchSvg className="w-5 h-5" />
      </div>
      <input
        value={value}
        onChange={({ target }) => {
          onChange(target.value)
        }}
        placeholder={t('bottom_menu.search')}
        className="flex-1 justify-start text-foregrounds-fg-base text-xs font-normal font-Montserrat leading-5 h-full w-full outline-none bg-transparent placeholder:text-foregrounds-fg-muted"
      />
    </div>
  )
}

export default SearchInput
